//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import Vue from "vue";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import {
    mapState, mapMutations, mapGetters, mapActions
} from "vuex";

import { AgGridVue } from "ag-grid-vue";
import { infoToastPublish, publishAppPermissions } from "@/assets/js/appFunc";
import draggable from "vuedraggable";
import InterfaceLoad from "@/components/UserInterfaces/mixins/interface-load";
import InterfaceUtils from "@/components/UserInterfaces/mixins/interface-utils";
import QfUiLeftContainer from "@/components/UserInterfaces/left-container/qf-ui-left-container.vue";
import QfComponentsRenderer from "@/components/UserInterfaces/qf-components-renderer.vue";
import QfUiRightContainer from "@/components/UserInterfaces/right-container/qf-ui-right-container.vue";
import QfComponentsPage from "@/components/UserInterfaces/qf-components-page.vue";

import InterfaceRenderer from "@/components/UserInterfaces/renderer/InterfaceRenderer.vue";
import BodyRenderer from "@/components/UserInterfaces/renderer/BodyRenderer.vue";

import ComponentsLoading from "@/components/UserInterfaces/mixins/components-loading";
import ComponentsAdding from "@/components/UserInterfaces/mixins/components-adding";
import DataModel from "@/components/UserInterfaces/mixins/datamodel-utils";
import SaveValidations from "@/components/UserInterfaces/mixins/save-validations";

/* Properties components */
import QfLabelSpacer from "@/components/UserInterfaces/properties/qf-label-spacer.vue";
import QfActionTrigger from "@/components/UserInterfaces/properties/qf-action-trigger.vue";
import QfPTextFont from "@/components/UserInterfaces/properties/text-font/qf-p-text-font.vue";
import QfPGet from "@/components/UserInterfaces/properties/get/qf-p-get.vue";
import QfPSet from "@/components/UserInterfaces/properties/set/qf-p-set.vue";
import QfPGetSet from "@/components/UserInterfaces/properties/getset/qf-p-get-set.vue";
import QfPValidationType from "@/components/UserInterfaces/properties/validation/qf-p-validation-type.vue";
import QfPTextValidation from "@/components/UserInterfaces/properties/validation/qf-p-text-validation.vue";
import QfPNumberDataFormat from "@/components/UserInterfaces/properties/validation/qf-p-number-data-format.vue";
import QfPOtherValidation from "@/components/UserInterfaces/properties/validation/qf-p-other-validation.vue";

import QfPValues from "@/components/UserInterfaces/properties/values/qf-p-values.vue";
import QfPContainers from "@/components/UserInterfaces/properties/containers/qf-p-containers.vue";
import QfPIndex from "@/components/UserInterfaces/properties/index/qf-p-index.vue";
import QfPIcons from "@/components/UserInterfaces/properties/icons/qf-p-icons.vue";
import QfPColors from "@/components/UserInterfaces/properties/colors/qf-p-colors.vue";
import QfPDataModel from "@/components/UserInterfaces/properties/data-model/qf-p-insert-data-model.vue";
import QfPScriptEditor from "@/components/UserInterfaces/properties/script-editor/qf-p-script-editor.vue";
import QfPAlignSelect from "@/components/UserInterfaces/properties/align-select/qf-p-align-select.vue";
import QfPRichEditor from "@/components/UserInterfaces/properties/rich-editor/qf-p-rich-editor.vue";
import QfPColumnEditor from "@/components/UserInterfaces/properties/column-editor/qf-p-column-editor.vue";
import QfPApiMapping from "@/components/UserInterfaces/properties/api-mapping/qf-p-api-mapping.vue";
import QfPBlockchainMapping from "@/components/UserInterfaces/properties/blockchain-mapping/qf-p-blockchain-mapping.vue";
import QfPProcessConfigure from "@/components/UserInterfaces/properties/configure-process/qf-p-process-configure.vue";
import QfPInputs from "@/components/UserInterfaces/properties/inputs-mapping/qf-p-inputs.vue";
import QfMetamaskMapping from "@/components/UserInterfaces/properties/metamask-mapping/qf-p-metamask-mapping.vue";
import QfField from "@/components/UserInterfaces/components/field/QfField.vue";
import QfSelect from "@/components/UserInterfaces/components/select/QfSelect.vue";
import AQDateTimePicker from "@/components/UserInterfaces/components/datetimepicker/AQDateTimePicker.vue";
import UiFragment from "@/components/UserInterfaces/components/fragment/UiFragment.vue";

import GlobalUtils from "@/components/UserInterfaces/plugins/globalUtils";
import MediaRecorder from "@/pages/fabricInterface/components/media-recorder-plugin/media-recorder.vue";
import AQPdfViewer from "@/pages/fabricInterface/components/pdf-preview-modal/AQPdfViewer.vue";
import AWalletSign from "@/components/Generics/AWallet/AWalletSign.vue";
import AQDialog from "../../../../components/Generics/AQDialog/AQDialog.vue";
import ActiveComponentMethods from "./mixins/active-component-methods";
import NativeEvents from "./mixins/native-events";
import { diff } from "deep-object-diff";
import FroalaComponent from "@/components/UserInterfaces/components/froala/FroalaComponent.vue";

import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import { date } from "quasar";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import i18n from "@/i18n/index";

Vue.component("BodyRenderer", BodyRenderer);

Vue.component("QfField", QfField);
Vue.component("QfSelect", QfSelect);

Vue.component("QfComponentsRenderer", QfComponentsRenderer);
Vue.component("QfLabelSpacer", QfLabelSpacer);
Vue.component("QfActionTrigger", QfActionTrigger);
Vue.component("QfPGet", QfPGet);
Vue.component("QfPSet", QfPSet);
Vue.component("QfPGetSet", QfPGetSet);
Vue.component("QfPValidationType", QfPValidationType);
Vue.component("QfPTextValidation", QfPTextValidation);
Vue.component("QfPNumberDataFormat", QfPNumberDataFormat);
Vue.component("QfPOtherValidation", QfPOtherValidation);
Vue.component("QfPValues", QfPValues);
Vue.component("QfPContainers", QfPContainers);
Vue.component("QfPIndex", QfPIndex);
Vue.component("QfPIcons", QfPIcons);
Vue.component("QfPColors", QfPColors);
Vue.component("QfPDataModel", QfPDataModel);
Vue.component("QfPScriptEditor", QfPScriptEditor);
Vue.component("QfPRichEditor", QfPRichEditor);
Vue.component("QfPColumnEditor", QfPColumnEditor);

Vue.component("QfPApiMapping", QfPApiMapping);
Vue.component("QfPBlockchainMapping", QfPBlockchainMapping);
Vue.component("QfPProcessConfigure", QfPProcessConfigure);
Vue.component("QfPMetamaskMapping", QfMetamaskMapping);
Vue.component("QfPTextFont", QfPTextFont);
Vue.component("QfPAlignSelect", QfPAlignSelect);
Vue.component("UiFragment", UiFragment);
Vue.component("AgGridVue", AgGridVue);
Vue.component("MediaRecorder", MediaRecorder);
Vue.component("AQPdfViewer", AQPdfViewer);
Vue.component("AWalletSign", AWalletSign);
Vue.component("AQDateTimePicker", AQDateTimePicker);
Vue.component("Draggable", draggable);
Vue.component("FroalaComponent", FroalaComponent);

Vue.component("QfPInputs", QfPInputs);
Vue.use(GlobalUtils);

export default {
    name: "UserInterfaces",
    components: {
        InterfaceRenderer, QfComponentsPage, QfUiRightContainer, QfUiLeftContainer, AQDialog, AQModal, AQHistory, AQInput
    },
    mixins: [ComponentsLoading, ComponentsAdding, NativeEvents, DataModel, ActiveComponentMethods, SaveValidations, InterfaceLoad, InterfaceUtils],
    beforeRouteEnter(to, from, next) {
        // TODO: make this work again, as after this became a component, the nav guards no longer work here
        next($vm => {
            $vm.setRouteEnter(true);
            if ($vm.latestVersion) {
                $vm.getRawDataModel().then(() => {
                    $vm.parseCatalogsRawData();
                    $vm.parseModelClassesRawData();
                });

                Promise.all([$vm.getRawExternalAPIs(), $vm.getRawSystemVariables()])
                    .then(([rawExternalAPIs, rawSystemVariables]) => {
                        $vm.parseAPIsRawData(rawExternalAPIs);
                        $vm.parseSystemVariables(rawSystemVariables);
                    });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        // TODO: make this work again, as after this became a component, the nav guards no longer work here
        const { leftContainer } = this.$refs;
        leftContainer.checkForModifications().then(data => {
            this.updateLive();
            this.setInterfaceDirty(data);
            this.$root.$emit("showCheckedSaveBtn", !data);
            next();
        });
    },
    props: {
        uid: { type: String, default: null }
    },
    data() {
        return {
            thumb: {
                right: "2px", borderRadius: "4px", width: "5px", opacity: 0.3
            },
            pageName: this.$t("userInterface.userInterfaces"),
            templateFragment: null,
            templateData: null,
            generatedTemplate: null,
            showDataModel: false,
            lastCount: 0,
            dirty: false,
            dirtyFromRestore: false,
            loading: false,
            codeOk: false,
            nameOk: false,
            importFile: false,
            savedInterface: false,
            refreshToast: null,
            savedTriggered: false,
            deleteAlert: false,
            setDiffsInterval: null,
            saveHistoryData: [],
            saveHistoryModal: false,
            saveHistoryCurrentPage: 0,
            saveHistoryHasMoreItems: true,
            saveHistoryActiveCommitId: null,
            savePreviewToast: null,
            noteDialog: false,
            noteDialogTitle: null,
            confirmLabel: null,
            note: null,
            saveHistoryPreviewToast: false,
            saveHistoryPreviewDate: null,
            currentPreviewInterface: null,
            createNote: false,
            openDialogDraftPreview: false,
            restoreConfirmationDialog: false,
            restoreDialogMessage: null,
            restoredInterfaceData: null,
            previewDone: false,
            standaloneTypes: new Set(["publish", "delete", "recover"]),
            keyUpdate: 0,
            dialogAction: "",
            timeStampPreview: null,
            inPreviewMode: false
        };
    },
    computed: {
        ...mapState("components", [
            "fragments", "readOnly", "activeInterface", "currentInterfaceProperties", "currentInterfaceModel", "routeEnter",
            "live", "slots", "qfDebug", "data", "properties", "containers", "bodyReference", "element", "activeComponent",
            "latestVersion", "activeInterface", "appInterfaces", "emptyInterface", "currentAddedComponent", "legacyRenderer",
            "goToComponent"
        ]),
        ...mapState("main", ["currentApplicationId", "interfaceDirty"]),
        ...mapGetters("components", ["body"]),
        ...mapGetters("documentEditor", ["appWasUpdated"]),
        ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions", "processList"]),
        createNoteDisabled() {
            return !this.note && this.createNote;
        },
        isReadonly() {
            return this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
        }
    },
    watch: {
        activeInterface(value) {
            if (value && value !== "draft" && !this.isReadonly) {
                this.$oneAtATime.createRoom("iBuilder", value);
            }
            this.resetSaveHistory();
            this.dirtyFromRestore = false;
        },
        currentApplicationId() {
            if (this.latestVersion) {
                this.$refs.leftContainer.clearActiveInterface();
                this.getLatestAppInterfaces();
            }
        },
        "$backendWebsocketEvents.state.refreshGuiList": function (v) {
            if (v) {
                const { id } = v;
                const { data } = v;
                const eventInfo = data.split(":");
                const guid = eventInfo[2];
                const actionType = eventInfo[3];
                if (this.currentApp.id === id && this.$route.name === "userInterfaces") {
                    if (this.activeInterface === "draft" && !this.savedTriggered) {
                        this.draftContent = { ...this.currentInterfaceProperties };
                        this.refreshWithDraft();
                    } else if (actionType === "persist") {
                        const interfaceUpdated = this.appInterfaces.find(el => el.id === guid);
                        if (this.activeInterface !== "draft" && this.activeInterface !== guid) {
                            this.refreshList(interfaceUpdated);
                        } else if (!this.$oneAtATime.state.$currentRoomEmpty) {
                            this.showRefreshToast(interfaceUpdated.name);
                        }
                    } else if (actionType === "import" && !this.importFile) {
                        this.refreshList();
                    } else if (actionType === "delete") {
                        if (this.activeInterface !== guid) { // cazul in care se fac delete dar userii nu sunt pe aceeasi interfata
                            this.refreshListAfterDelete();
                        } else if (this.activeInterface && !this.$oneAtATime.state.$currentRoomEmpty) { // se face delete si sunt doi useri pe aceeasi interfata
                            this.$root.$emit("deletedInterface", true);
                            this.$toast.showNotify({
                                type: "info",
                                message: `The ${this.currentInterfaceProperties.name} interface has been deleted by
                                        ${this.$oneAtATime.state.$currentEditingUser}.`,
                                timeout: 3000
                            });
                            this.$refs.leftContainer.sideCategory = "pages";
                            this.setLive(false);
                            this.getLatestAppInterfaces();
                            this.setActiveInterface(null);
                            const components = { components: {}, body: [] };
                            this.__loadInterfaceFromJSON(components);
                            this.$emit("clear-selected-interface");
                        }
                    } else if (actionType === "rename") {
                        this.refreshListAfterRename(eventInfo[4]);
                    }
                    this.$backendWebsocketEvents.state.refreshGuiList = false;
                }
            }
        },
    },
    created() {
        this.setDesigner(true);
        this.setActiveInterface(null);
        this.setActivityId(null);

        if (!this.processList.length) {
            this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm: "" }).then(rsp => {
                if (rsp.data) {
                    this.$store.commit("apps/setProcessList", rsp.data);
                }
            });
        }

        this.$root.$on("nodeClicked", () => {
            if (this.refreshToast) {
                this.refreshToast();
            }
            this.savedInterface = false;
        });

        this.__loadComponents().then(() => {
            this.__parseComponentCategories();
            this.getDataModelLatestVersion().then(() => {
                // this.getLatestAppInterfaces().then(() => {
                //     this.$root.$emit("enabledBtn", false);
                // });

                const dataClassesCatalogs = this.getRawDataModel().then(() => {
                    this.parseCatalogsRawData();
                    this.parseModelClassesRawData();
                });

                const dataAPIVariables = Promise.all([this.getRawExternalAPIs(), this.getRawSystemVariables()])
                    .then(([rawExternalAPIs, rawSystemVariables]) => {
                        this.parseAPIsRawData(rawExternalAPIs);
                        this.parseSystemVariables(rawSystemVariables);
                    });

                Promise.all([dataClassesCatalogs, dataAPIVariables]).then(() => {
                    if (this.uid.startsWith("draft")) {
                        this.addInterfaceList(this.uid.split("_")[1]);
                    } else {
                        this.loadInterface({ guid: this.uid, update: true });
                    }
                })


                // this.getRawDataModel().then(() => {
                //     this.parseCatalogsRawData();
                //     this.parseModelClassesRawData();
                // });
                //
                // Promise.all([this.getRawExternalAPIs(), this.getRawSystemVariables()])
                //     .then(([rawExternalAPIs, rawSystemVariables]) => {
                //         this.parseAPIsRawData(rawExternalAPIs);
                //         this.parseSystemVariables(rawSystemVariables);
                //     });
            });
        });

        this.$root.$on("ui-render-interface", () => {
            this.templateFragment = this.body;
            this.setData(this.__generateData());
            this.templateData = this.data;
        });
        this.$root.$on("fromImport", value => {
            this.importFile = value;
        });

        this.$root.$on("userInterfacesSave", () => {
            const { code = "", name = "", type = "GUI", id } = this.currentInterfaceProperties;
            const { path } = this.$route;
            let fragmentCheck = true;
            this.savedTriggered = true;
            this.dirtyFromRestore = false;

            if (type === "FRAGMENT") {
                const hasFragment = Object.keys(this.properties).some(key => this.properties[key].__component === "ctrl-fragment");
                if (hasFragment) {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("userInterface.fragmentError"),
                        code: "ui-snok",
                        timeout: 2000
                    });
                    fragmentCheck = false;
                }
            }

            if (fragmentCheck) {
                if ((this.__validateName(name) === 0) && (this.__validateCode(code) === 0)) {
                    this.saveInterface()
                        .then(guid => {
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("userInterface.saveInterface"),
                                code: "ui-sok",
                                timeout: 2000
                            });
                            // this.$refs.leftContainer.updateActiveInterface(guid);
                            // this.$root.$emit("focusName");
                            this.$store.commit("main/setLastUpdate", { date: new Date(), name: this.$route.name });
                            // this.$root.$emit("draft", false);
                            this.$store.commit("main/setInterfaceDirty", false);
                            this.$root.$emit("showCheckedSaveBtn", true);
                            this.savedTriggered = false;
                            this.loadInterface(guid);
                            this.getAppSettingsInfo(this.currentApp).then(data => {
                                this.currentApp.publishStatus = data.data.publishStatus;
                                this.$store.commit("apps/setCurrentApp", this.currentApp);
                                this.$root.$emit("showPublish", {   noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses") ? !this.currentApp.nrOfProcesses : !this.processList.length,
                                                                    showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
                            });
                            const selectedType = type === "GUI" ? "userInterfaces" : "fragments";
                            if (!path.includes(selectedType) || path.includes("createNew")) {
                                this.$router.replace({ path: `/applications/${this.currentApp.id}/${selectedType}/${id}` }).then(
                                    () => this.$root.$emit("showCheckedSaveBtn", true)
                                );
                            }
                            // this.setCurrentInterfaceModel(this.properties);
                        })
                        .catch(() => {
                            this.$toast.showNotify({
                                type: "error",
                                message: this.$t("userInterface.errorInterface"),
                                code: "ui-snok",
                                timeout: 2000
                            });
                            this.$root.$emit("draft", true);
                            this.savedTriggered = false;
                        });
                } else if (this.activeComponent) {
                    this.setSaveErrors(true);
                    this.setActiveComponent(null);
                }
            }
            this.draftContent = null;
        });
        this.$root.$on("previewSaveHistoryClose", routeName => {
            if (routeName === this.$route.name) {
                if (this.savePreviewToast) {
                    this.savePreviewToast();
                }
                this.saveHistoryActiveCommitId = null;
                this.dirtyFromRestore = false;
                this.inPreviewMode = false;
                if (this.activeInterface) {
                    this.loadInterface({ guid: this.activeInterface, update: true });
                    this.checkPermissions();
                }
            }
        });
        this.$root.$on("restore", () => {
            this.infoRestoreDialog();
            this.restoreConfirmationDialog = true;
        })
    },
    beforeCreate() {
        window.Vue = Vue;
    },
    beforeDestroy() {
        this.$oneAtATime.destroyCurrentRoom();
        if (this.refreshToast) {
            this.refreshToast();
        }
        this.$root.$off("backendWebsocketEvents-publishedApp");
        this.$root.$off("openSaveHistory");
        this.$root.$off("openNoteDialog");
        this.$root.$off("showMoreSaveHistory");
        this.$root.$off("startEditing");
        this.$root.$off("oneAtATime-iBuilder");
        this.$root.$off("bc__currentInterface__rename");
        this.$root.$off("bc__interfaces__open");
        this.setActiveInterface(null);
        this.setLive(false);
        this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);

        this.$root.$off("nodeClicked");
        this.$root.$off("ui-render-interface");
        this.$root.$off("fromImport");
        this.$root.$off("userInterfacesSave");
        this.$root.$off("previewSaveHistoryClose");
        this.$root.$off("restore");

        document.removeEventListener("keydown", this.onKeyDown, false);
        clearInterval(this.setDiffsInterval);
        this.setDesigner(false);
        this.setAiActions([]);
    },
    mounted() {
        this.$root.$on("openNoteDialog", routeName => {
            if (routeName === this.$route.name) {
                this.getNoteData();
            }
        })
        this.$root.$on("openSaveHistory", routeName => {
            if (routeName === this.$route.name) {
                if (this.saveHistoryActiveCommitId) {
                    if (this.savePreviewToast) {
                        this.savePreviewToast();
                    }
                    this.saveHistoryModal = true;
                    this.$nextTick(() => {
                        const activePreviewListItem = document.querySelectorAll(".timeline_list_item.active.edit");
                        if (activePreviewListItem.length) {
                            activePreviewListItem[0].scrollIntoView();
                        }
                    });
                } else {
                    this.resetSaveHistory();
                    this.getSaveHistory();
                }
            }
        });
        this.$root.$on("showMoreSaveHistory", routeName => {
            if (routeName === this.$route.name) {
                this.saveHistoryCurrentPage += 1;
                this.getSaveHistory();
            }
        });
        this.$root.$on("startEditing", () => {
            if (this.refreshToast) {
                this.refreshToast();
                this.updateInterface();
            }
        });
        this.updatePageReference(this.$refs.page.$el);
        document.addEventListener("keydown", this.onKeyDown, false);

        this.$root.$on("oneAtATime-iBuilder", () => {
            this.checkPermissions({ readonly: !this.$oneAtATime.state.$currentRoomEmpty });
        });

        this.$root.$on("bc__interfaces__open", this.crumbOpen);
        this.$root.$on("bc__currentInterface__rename", data => {
            this.rename(data);
        })
            this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
            this.checkPermissions();
            if (this.appWasUpdated) {
                this.getDataModelLatestVersion().then(() => this.getLatestAppInterfaces());
            }
            this.$root.$on("backendWebsocketEvents-publishedApp", data => {
                infoToastPublish(data);
                this.$root.$emit("changePublishError");
            });
            this.$root.$emit("previewMode",  this.$route.name);
    },
    methods: {
        ...mapMutations("components", [
            "setActiveInterface", "resetInterface", "setCurrentInterfaceModel", "setLive", "setSaveErrors",
            "setDesigner", "setProperties", "setActiveComponent", "setActivityId"
        ]),
        ...mapMutations("components", ["setDesignerEventBus", "updatePageReference", "setRouteEnter", "removeComponent", "setReadonly", "setAiActions"]),
        ...mapMutations("main", ["setCurrentApplicationId", "setInterfaceDirty"]),
        ...mapActions("components", ["getDataModelLatestVersion", "getLatestAppInterfaces", "saveInterface", "getInterfaceModel",
        "getCommitId", "getHistoryData", "saveDeleteNote", "getNote", "getHistoryPreviewData", "renameInterface"]),
        ...mapActions("apps", ["getAppProcesses", "getAppSettingsInfo"]),
        historyMenuClick(evt) {
            this.dialogAction = evt.actionName;
            if (this.dialogAction === 'restore') {
                this.infoRestoreDialog(evt.timelineItem);
                this.restoreConfirmationDialog = true;
            }
        },
        infoRestoreDialog(timelineItem) {
            this.restoredInterfaceData = timelineItem ? timelineItem :  this.currentPreviewInterface;
            const restoreElementData = timelineItem && timelineItem.timestamp ? `${this.dateFormatter(timelineItem.timestamp)}` :`${this.dateFormatter(this.currentPreviewInterface.timestamp)}`
            this.restoreDialogMessage =  this.$t(  "versioning.restoreDialogInfo", { interfaceName: timelineItem ? timelineItem.name : this.currentPreviewInterface.elementName, date: restoreElementData });
        },
        confirmRestore() {
            if( this.previewDone && this.restoredInterfaceData &&  this.restoredInterfaceData !== this.currentPreviewInterface || !this.previewDone ) {
                const payload = {
                    module: "UIBuilder",
                    applicationId: this.currentApp.id,
                    elementId: this.activeInterface,
                    commitId:  this.restoredInterfaceData.commitId
                };
                this.getHistoryPreviewData(payload).then(data => {
                    if (data && data.properties) {
                        this.$root.$emit("hideSaveBtn", false);
                        this.$root.$emit("showCheckedSaveBtn", false);
                        this.$root.$emit("confirmRestore", this.$route.name);
                        this.__resetColors();
                        const components = (data.model && data.model.interfaceJson) || { components: {}, body: [] };
                        this.__loadInterfaceFromJSON(components);
                        if (components.hasOwnProperty("config") && components.config.hasOwnProperty("theme")) {
                            this.__loadThemeObject(components.config.theme);
                        }
                        if (components.hasOwnProperty("config") && components.config.hasOwnProperty("aiActions")) {
                            this.setAiActions(components.config.aiActions);
                        } else if (components.hasOwnProperty("config") && !components.config.hasOwnProperty("aiActions")) {
                            this.setAiActions([]);
                        }
                        this.setActiveInterface({guid: this.activeInterface, previewInterfaceProp: data.properties});
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("versioning.confirmRestoreNotify"),
                            timeout: 2000
                        });
                    }
                });
            }
            this.$root.$emit("showPublish", {   noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses") ? !this.currentApp.nrOfProcesses : !this.processList.length,
                                                showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            this.saveHistoryActiveCommitId = null;
            this.resetSaveHistory();
            this.dirtyFromRestore = true;
            this.$store.commit("main/setInterfaceDirty", true);
            this.saveHistoryModal = false;
            this.inPreviewMode = false;
            this.setReadonly(false);
            this.$root.$emit("hideSaveBtn", false);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$root.$emit("confirmRestore", this.$route.name);

        },
        getNoteData() {
            if (this.currentPreviewInterface) {
                const payload = {
                module: "UIBuilder",
                applicationId: this.currentApp.id,
                elementId: this.activeInterface,
                commitId: this.currentPreviewInterface.commitId,
            }
            this.getNote(payload).then( data => {
                if (data) {
                    this.note = data.data;
                    this.createNote = !this.note;
                    this.confirmLabel = this.note ? this.$t("versioning.updateNote") : this.$t("versioning.createNote");
                    this.noteDialogTitle = this.note ?
                        this.$t("versioning.dialogTitleEdit", { date: `${this.dateFormatter(this.currentPreviewInterface.timestamp)}`}) :
                        this.$t("versioning.dialogTitleCreate", { date: `${this.dateFormatter(this.currentPreviewInterface.timestamp)}` });
                }
                this.noteDialog = true;
            })
            }
        },
        actionNote(noteData) {
            let payload = {
                module: "UIBuilder",
                applicationId: this.currentApp.id,
                elementId: this.activeInterface,
            }
            payload.commitId = noteData ? noteData.timelineItem.commitId : this.currentPreviewInterface.commitId;
            payload.note = noteData ? noteData.note : this.note;
            let messageLabel = "";
            if (noteData) {
                messageLabel = this.dialogAction === "edit" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            } else {
                messageLabel = this.confirmLabel === "Update" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            }
            this.saveDeleteNote(payload).then((data) => {
                if (data) {
                    this.$toast.showNotify({
                        type: "success",
                        message: messageLabel,
                        timeout: 500,
                        hasClose: true,
                    });
                    if (noteData) {
                        noteData.timelineItem.note = noteData.note;
                        this.keyUpdate += 1;
                    } else if (this.currentPreviewInterface) {
                        this.currentPreviewInterface.note = this.note;
                    }
                }
            },
            err => {console.log("error",err)})
        },
        crumbOpen(guid) {
            this.$emit("previewSaveHistoryClose", this.$route.name);
            this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
            this.$store.commit("main/setInterfaceDirty", false);
            const type = this.currentInterfaceProperties.type === "FRAGMENT" ? "fragments" : "userInterfaces";
            this.$router.replace({ path: `/applications/${this.currentApp.id}/${type}/${guid}` }).then(
                () => {
                    this.loadInterface({ guid, update: true}, null, true);
                    this.$root.$emit("showCheckedSaveBtn", true)
                }
            );
        },
        rename(interfaceNameObj) {
            if(interfaceNameObj.newName) {
                this.currentInterfaceProperties.name = interfaceNameObj.newName;
                this.currentInterfaceProperties._details.name = interfaceNameObj.newName;
                if(this.activeInterface !== "draft") {
                    const payload = {
                    appId: this.currentApp.id,
                    id: this.activeInterface,
                    name: interfaceNameObj.newName
                };
                this.renameInterface(payload).then(
                    data => {
                        if (data && data.data) {
                            this.currentApp.publishStatus = data.data.status ? "UNPUBLISHED_CHANGES" : "PUBLISHED";
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("userInterface.renamedSuccessfully"),
                                timeout: 2000
                            });
                        }
                     },
                    err => {
                        this.currentInterfaceProperties._details.name = interfaceNameObj.oldName;
                        this.currentInterfaceProperties.name = interfaceNameObj.oldName;
                        console.log(err)
                    })
                }
            } else {
                this.currentInterfaceProperties._details.name = interfaceNameObj.oldName;
                this.currentInterfaceProperties.name = interfaceNameObj.oldName;
                this.$toast.showNotify({
                type: "info",
                message: this.$t("versioning.emptyNameNotif"),
                timeout: 2000
             });
            }
        },
        loadInterface(payload, showSave, interfaceChanged) {
            const gui = payload.guid || payload;
            this.selected = gui;
            this.getInterfaceModel(payload).then(data => {
                if (data && data.properties) {
                    this.$root.$emit("hideSaveBtn", false);
                    // ToDo: check this
                    this.$root.$emit("showCheckedSaveBtn", typeof showSave !== "boolean");
                    this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                            ? !this.currentApp.nrOfProcesses : !this.processList.length,
                        showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
                    this.$store.commit("components/updateAppInterface", { guid: data.properties.id, data: data.properties });
                }
                this.__resetColors();
                const components = (data.model && data.model.interfaceJson) || { components: {}, body: [] };

                if (components.hasOwnProperty("config")) {
                    if (components.config.hasOwnProperty("theme")) {
                        this.__loadThemeObject(components.config.theme);
                    }

                    if (components.config.hasOwnProperty("legacyRenderer")) {
                        this.$store.commit("components/setLegacyRenderer", components.config.legacyRenderer);
                    } else {
                        const { legacyRenderer } = this.$store.state.components;
                        this.$store.commit("components/setLegacyRenderer", legacyRenderer);
                    }
                }

                this.__loadInterfaceFromJSON(components);
                this.setActiveInterface(gui);
                this.checkPermissions();
                if (!this.activeInterface) {
                    this.$root.$emit("hideSaveBtn", true);
                    this.$root.$emit("showCheckedSaveBtn", false);
                }
                if (this.appWasUpdated) {
                    this.getDataModelLatestVersion().then(() => this.getLatestAppInterfaces());
                }
                if (interfaceChanged) {
                    this.$store.commit("main/setInterfaceDirty", false);
                }
                this.checkForDiifs();
            });
        },
        addInterfaceList(type) {
            this.$root.$emit("hideSaveBtn", false);
            this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                    ? !this.currentApp.nrOfProcesses : !this.processList.length,
                showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            this.$store.commit("main/setSaveBtnVisible", false);
            this.setReadonly(false);

            this.resetInterface({ type, guid: "draft" });
            this.$store.commit("components/addAppInterface", Object.assign({}, this.emptyInterface, { type }));
            this.$store.commit("main/setInterfaceDirty", true);
            this.selected = null;
            this.$nextTick(() => {
                this.__resetColors();
            });
            this.draft = true;
        },
        checkForDiifs() {
            this.setDiffsInterval = setInterval(() => {
                if (this.activeInterface) {
                    const { _details = {}, type, code, name, description } = this.currentInterfaceProperties;
                    const { type: iType, code: iCode, name: iName, description: iDescription } = _details;
                    if (this.activeInterface === "draft") {
                        this.$root.$emit("showCheckedSaveBtn", false);
                    } else if (type !== iType || code !== iCode || name !== iName || ((description || "") !== (iDescription || ""))) {
                       this.$root.$emit("showCheckedSaveBtn", false);
                       this.$store.commit("main/setInterfaceDirty", true);
                    } else {
                        const original = this.currentInterfaceModel;
                        const differences = diff(original, this.properties);

                        if (Object.keys(differences).length > 0) {
                            this.$root.$emit("showCheckedSaveBtn", false);
                            this.$store.commit("main/setInterfaceDirty", true);
                            this.dirty = true;
                        } else {
                            this.dirty = false;
                        }
                    }
                }
            }, 1500);
        },
        showRefreshToast(name) {
            if (!this.savedInterface) {
                this.savedInterface = true;
                this.refreshToast = this.$toast.showNotify({
                    type: "info",
                    message: `${name} ${this.$t("userInterface.updateInterface")}`,
                    buttonLabel: this.$t("userInterface.refresh"),
                    timeout: 0,
                    hasClose: false,
                    actionEvent: this.updateInterface
                });
            }
        },
        updateInterface() {
            this.getLatestAppInterfaces().then(() => {
                this.getInterfaceModel({ guid: this.activeInterface, update: true }).then(data => {
                    this.__resetColors();
                    const components = (data.model && data.model.interfaceJson) || { components: {}, body: [] };
                    if (components.hasOwnProperty("config") && components.config.hasOwnProperty("theme")) {
                        this.__loadThemeObject(components.config.theme);
                    }
                    this.__loadInterfaceFromJSON(components);
                    this.setActiveInterface(this.activeInterface);
                });
                this.savedInterface = false;
            });
        },
        updateLive() {
            this.setData(this.__generateData());
            this.templateData = this.data;
            this.setLive(false);
        },
        componentsRendererUpdate() {
            const componentsCount = this.body.length;
            if (this.lastCount < componentsCount) {
                const { renderScroll } = this.$refs;
                renderScroll.scrollTop = renderScroll.scrollHeight;
                this.lastCount = componentsCount;
            }
        },
        rightContainerAction(payload) {
            const { action } = payload;

            if (action === "add-slot") {
                this.actionAddSlot();
            } else if (action === "live-test") {
                this.actionLiveTest(payload.state);
            }
        },
        actionAddSlot() {
            const data = { type: "ctrl-slot", to: this.activeComponent, near: false };

            if (this.__createComponent(data)) {
                this.templateFragment = this.body;
                this.templateData = this.data;
            }
        },
        actionLiveTest(state) {
            if (!state) {
                this.setData(this.__generateData());
                this.templateData = this.data;
            }
            this.setLive(state);
        },
        refreshList(interf) {
            if (interf) {
                this.getLatestAppInterfaces().then(() => {
                    const messageUpdate = `${interf.name} ${this.$t("userInterface.interfaceUpdate")}`;
                    this.$toast.showNotify({
                        type: "info",
                        message: messageUpdate,
                        timeout: 1000
                    });
                });
            } else if (this.activeInterface !== "draft") {
                this.getLatestAppInterfaces().then(() => {
                    const messageUpdate = this.$t("userInterface.listUpdate");
                    this.showToastUpdate(messageUpdate);
                });
            }
        },
        refreshListAfterDelete() {
            if (this.activeInterface !== "draft") {
                this.getLatestAppInterfaces();
            }
        },
        refreshListAfterRename(name) {
            if (this.activeInterface && !this.$oneAtATime.state.$currentRoomEmpty) {
                this.$toast.showNotify({
                    type: "info",
                    message: `${name} ${this.$t("documents.renamed")}`,
                    timeout: 1000
                });
                setTimeout(() => {
                    this.refreshToast = this.$toast.showNotify({
                        type: "info",
                        message: `${name} ${this.$t("userInterface.updateInterface")}`,
                        buttonLabel: this.$t("userInterface.refresh"),
                        timeout: 0,
                        hasClose: false,
                        actionEvent: this.updateInterface
                    });
                }, 1000);
                this.getLatestAppInterfaces();
            }
        },
        refreshWithDraft() {
            const messageUpdate = this.$t("userInterface.listUpdate");
            this.getLatestAppInterfaces().then(() => {
                if (this.draftContent) {
                    this.$store.commit("components/addAppInterface", this.draftContent);
                    this.setActiveInterface(this.draftContent.id);
                    this.$refs.leftContainer.$refs.screens.selected = this.draftContent.id;
                }
                this.showToastUpdate(messageUpdate);
            });
        },
        showToastUpdate(messageUpdate) {
            this.$toast.showNotify({
                type: "info",
                message: messageUpdate,
                timeout: 1000
            });
        },
        leftContainerAction(payload) {
            if (payload.type === "add-component") {
                const data = {
                    type: payload.data.type, to: this.activeComponent || "body", near: payload.data.shift, id: payload.data.id
                };
                let hasFragment = false; let segmentAdd = false; let
                    inception = false;

                if (data.id) {
                    const { id, type } = this.currentInterfaceProperties;

                    inception = type === "FRAGMENT" && id === data.id;
                    if (!inception) {
                        hasFragment = Object.keys(this.properties).some(key => {
                            const { __component, fragment = null } = this.properties[key];
                            return __component === "ctrl-fragment" && fragment === data.id;
                        });

                        if (!hasFragment && (data.to !== "body")) {
                            const { namespace = false } = this.components[this.properties[data.to].__component];
                            segmentAdd = namespace;
                        }
                    }
                }

                if (inception) {
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("userInterface.sameFragment"),
                        code: "ui-frgNOk",
                        timeout: 2000
                    });
                } else if (hasFragment) {
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("userInterface.addedFragment"),
                        code: "ui-frgNOk",
                        timeout: 2000
                    });
                } else if (segmentAdd) {
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("userInterface.addedSegment"),
                        code: "ui-frgNOk",
                        timeout: 2000
                    });
                } else if (this.__createComponent(data)) {
                    this.templateFragment = this.body;
                    this.templateData = this.data;
                    if (this.currentAddedComponent) {
                        this.setActiveComponent(this.currentAddedComponent);
                    }
                }
            }
        },
        notifyErrors() {
            if (!this.codeOk) {
                this.$toast.showNotify({
                    type: "warning",
                    message: this.$t("userInterface.codeMandatory"),
                    code: "ui-codeNOk",
                    timeout: 2000
                });
            }

            if (!this.nameOk) {
                this.$toast.showNotify({
                    type: "warning",
                    message: this.$t("userInterface.nameMandatory"),
                    code: "ui-codeNOk",
                    timeout: 2000
                });
            }
        },
        onKeyDown(ev) {
            if (ev.keyCode === 46 && ev.shiftKey) {
                if (this.activeComponent && !this.readOnly) {
                    this.deleteAlert = true;
                }
            }
        },
        deleteElement() {
            this.removeComponent(this.activeComponent);
        },
        checkPermissions(oneAtATime) {
            if (this.isReadonly) {
                this.setReadonly(this.isReadonly);
                this.$store.commit("main/setSaveBtnVisible", this.isReadonly);
                this.$root.$emit("setReadonlyTag", this.isReadonly);
            } else if (oneAtATime) {
                this.setReadonly(oneAtATime.readonly);
                this.$store.commit("main/setSaveBtnVisible", oneAtATime.readonly);
                this.$root.$emit("setReadonlyTag", oneAtATime.readonly);
                if (this.activeInterface !== "newInterface") {
                    if (!oneAtATime.readonly && this.$oneAtATime.state.$startEdit) {
                        this.setActiveInterface(this.activeInterface);
                        this.getInterfaceModel({ guid: this.activeInterface, update: true }).then(data => {
                            this.__resetColors();
                            const components = (data.model && data.model.interfaceJson) || { components: {}, body: [] };

                            if (components.hasOwnProperty("config") && components.config.hasOwnProperty("theme")) {
                                this.__loadThemeObject(components.config.theme);
                            }
                            this.__loadInterfaceFromJSON(components);
                        });
                    }
                }
            } else {
                this.setReadonly(false);
                this.$store.commit("main/setSaveBtnVisible", false);
                this.$root.$emit("setReadonlyTag", false);
            }
        },
        modalActionSaveHistory(evt) {
            if (evt === "close") {
                this.saveHistoryModal = false;
                if (this.inPreviewMode) {
                    this.savePreviewToast = this.$toast.showNotify({
                        type: "info",
                        message: `${i18n.t("versioning.previewToastTitle")} ${this.dateFormatter(this.timeStampPreview)}`,
                        caption: this.$t("versioning.previewToastText"),
                        code: "preview-ui",
                        timeout: 30000000
                    });
                }
            }
        },
        getSaveHistory() {
            if (this.saveHistoryHasMoreItems && this.activeInterface !== 'draft') {
                const payload = {
                    searchType: "SAVE_HISTORY",
                    module: "UIBuilder",
                    applicationId: this.currentApp.id,
                    elementId: this.activeInterface,
                    page: this.saveHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if (data && data.data && data.data.history) {
                        this.saveHistoryData = this.saveHistoryData.concat(data.data.history);
                        this.saveHistoryHasMoreItems = data.data.hasMorePages;
                    }
                    this.saveHistoryModal = true;
                });
            } else {
                this.saveHistoryModal = true;
            }
        },
        getSaveHistoryPreview(timelineItem) {
            const isSamePreview = this.saveHistoryActiveCommitId ? this.saveHistoryActiveCommitId === timelineItem.commitId : false;
            if (!this.standaloneTypes.has(timelineItem.commitType) && !isSamePreview) {
                this.currentPreviewInterface = timelineItem;
                const dirtyNow = this.dirty || this.dirtyFromRestore;
                if (dirtyNow) {
                    this.openDialogDraftPreview = dirtyNow;
                } else {
                    this.getSaveHistoryItemPreview();
                }
            }
        },
        getSaveHistoryItemPreview() {
            if (!this.standaloneTypes.has(this.currentPreviewInterface.commitType)) {
                this.$root.$emit("previewSaveHistoryLoadStart", this.$route.name);
                const payload = {
                    module: "UIBuilder",
                    applicationId: this.currentApp.id,
                    elementId: this.activeInterface,
                    commitId: this.currentPreviewInterface.commitId
                };
                this.getHistoryPreviewData(payload).then(data => {
                    if (data && data.properties) {
                        this.$root.$emit("previewSaveHistoryLoadEnd", this.$route.name);
                        this.$root.$emit("hideSaveBtn", true);
                        this.$root.$emit("showPublish", false);

                        this.timeStampPreview = data.properties.timestamp;

                        this.previewDone = true;
                        this.inPreviewMode = true;
                        this.dirtyFromRestore = false;
                        this.setReadonly(true);
                        this.saveHistoryActiveCommitId = data.properties.commitId;

                        this.__resetColors();
                        const components = (data.model && data.model.interfaceJson) || { components: {}, body: [] };
                        this.__loadInterfaceFromJSON(components);
                        if (components.hasOwnProperty("config") && components.config.hasOwnProperty("theme")) {
                            this.__loadThemeObject(components.config.theme);
                        }
                        if (components.hasOwnProperty("config") && components.config.hasOwnProperty("aiActions")) {
                            this.setAiActions(components.config.aiActions);
                        } else if (components.hasOwnProperty("config") && !components.config.hasOwnProperty("aiActions")) {
                            this.setAiActions([]);
                        }
                        this.setActiveInterface({guid: this.activeInterface, previewInterfaceProp: data.properties});
                    } else {
                        this.$root.$emit("previewSaveHistoryClose", this.$route.name);
                    }
                });
            }
        },
        resetSaveHistory() {
            this.saveHistoryData = [];
            this.saveHistoryCurrentPage = 0;
            this.saveHistoryHasMoreItems = true;
            this.saveHistoryActiveCommitId = null;
            if (this.savePreviewToast) {
                this.savePreviewToast();
            }
        },
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            return `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}, ${year}  ${i18n.t("versioning.at")} ${hour}`;
        },
        componentRenderMounted() {
            if (!this.uid.startsWith("draft") && this.interfaceDirty) {
                this.$store.commit("main/setInterfaceDirty", false);
            }
        }
    }
};
